import { IDrawerSizeString, IDrawerSizeMeasure, DrawerSizeMeasures, IDrawerOverlayPosition, DrawerOverlayPositions } from '../DrawerOverlay';
export const getDrawerSizeStyles = ({
  size = 'auto',
  position = DrawerOverlayPositions.bottom
}) => {
  let height = '100%';
  let width = '100%';
  [DrawerOverlayPositions.bottom, DrawerOverlayPositions.top].includes(position) && (height = 'auto');
  [DrawerOverlayPositions.left, DrawerOverlayPositions.right].includes(position) && (width = 'auto');
  const regex = new RegExp(Object.keys(DrawerSizeMeasures).map(key => key).join('|'));
  const measureUnit = size.match(regex)?.[0];
  const measureValue = parseInt(size.replace(/\D/g, ''));
  if (measureUnit && !isNaN(measureValue)) {
    if ([DrawerOverlayPositions.left, DrawerOverlayPositions.right].includes(position)) {
      process.env.NODE_ENV === 'development' && measureUnit === 'vh' && console.warn('DrawerOverlay: Неверное соотношение единиц измерения и направления. ' + 'Автоматически исправлено с vh на vw.');
      width = `${measureValue}${measureUnit === 'vh' ? 'vw' : measureUnit}`;
    }
    if ([DrawerOverlayPositions.bottom, DrawerOverlayPositions.top].includes(position)) {
      process.env.NODE_ENV === 'development' && measureUnit === 'vw' && console.warn('DrawerOverlay: Неверное соотношение единиц измерения и направления. ' + 'Автоматически исправлено с vw на vh.');
      height = `${measureValue}${measureUnit === 'vw' ? 'vh' : measureUnit}`;
    }
  }
  return {
    height,
    width
  };
};